import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'avenir-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {

  // follow breakpoints.scss
  $l: number = 992;

  hideAt$l: boolean = false;

  ngOnInit(): void {
    if (window.innerWidth < this.$l) {
      this.hideAt$l = true;
    } else {
      this.hideAt$l = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event : any) {
    // console.log('Window resized', event.target.innerWidth);
    
    if (event.target.innerWidth < this.$l) {
      this.hideAt$l = true;
    } else {
      this.hideAt$l = false;
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    console.log('scroll');
  }  

}
